<template>
  <VContainer fluid class="login-picker">
    <VRow align-md="center" justify-md="center" class="h-100">
      <VCol cols="12" md="6" class="text-center">
        <div class="login-picker__img">
          <img :src="LoginSreen" alt="App preview" />
        </div>
      </VCol>
      <VCol cols="12" md="6" class="login-picker__content">
        <h1>booqimate</h1>
        <div class="login-picker__btns">
          <router-link to="/login" v-slot="{ navigate }">
            <v-btn variant="text" class="white" @click="navigate">Увійти</v-btn>
          </router-link>
          <router-link to="/signup" v-slot="{ navigate }">
            <v-btn variant="text" class="black" @click="navigate"
              >Додати бізнес</v-btn
            >
          </router-link>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script lang="ts" setup>
import LoginSreen from "@/main/assets/img/login-picker.png";
</script>

<style lang="scss" scoped>
.login-picker {
  height: 100vh;

  .v-row {
    @media screen and (max-width: 960px) {
      height: 100%;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 960px) {
      align-items: center;
      justify-content: flex-start;
      height: 100%;
    }
  }

  h1 {
    font-size: 50px;
    font-weight: 700;
    color: #504747;
    margin-bottom: 65px;
  }

  &__btns {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 300px;
    row-gap: 8px;
  }

  img {
    width: 100%;
  }

  &__img {
    max-width: 744px;
    margin-top: 55px;
  }

  .v-btn {
    height: 40px;
    width: 100%;
    font-size: 20px;
    font-weight: 500;
    padding: 0;

    &.white {
      background-color: #fff;
      color: #000;
    }

    &.black {
      background-color: #2e2a2a;
      color: #fff;
    }
  }
}
</style>
